<template>
  <div>
    <div class="col-lg-12">
      <Multiselect
        v-model="selectedCountry"
        :options="countryOptions"
        :multiple="true"
        :placeholder="$t('selectCountry')"
        :custom-label="customLabel"
        class="form-control"
      />
    </div>
    <br>
    <div
      v-for="company in companies"
      class="mb-4"
    >
      <div class="media align-items-center">
        <img
          class="rounded-circle user-image border mr-2"
          :src="getPhoto(company.logo,'thumbnailCropped')"
          alt=""
          style="width: 60px"
        >
        <div class="about">
          <div class="name f-w-600">
            {{ company.name }} {{ getCompanyFormat(company.format) }}
          </div>

          <div
            style="cursor: pointer"
            class="text-left"
            @click.prevent="$emit('openRatingPopup',{company: company, profile: profile})"
          >
            <div v-if="profile === 'PROCUREMENT'">
              <StarRatingView
                :count="company.procurementRateCount"
                :total="company.procurementRateTotal"
              />
            </div>

            <div v-else-if="profile === 'SUPPLIER'">
              <StarRatingView
                :count="company.supplyRateCount"
                :total="company.supplyRateTotal"
              />
            </div>
            <div v-else>
              <StarRatingView
                :count="0"
                :total="0"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {getSectorCompanyList} from "@/repositories/GeneralDataRepository";
import {mapState} from "vuex";
import {getCompanyFormat, getPhoto} from "@/repositories/Utils";
import StarRatingView from "@/pages/scc/utils/StarRatingView.vue";
import Multiselect from "vue-multiselect";

export default {
  name: 'SectorCompaniesModalContent',
  components: {Multiselect, StarRatingView},
  props: {
    sector: '',
    profile: '',
  },
  data() {
    return {
      selectedCountry: [this.$t('countries.ALL')], // The selected country
      countryCodes: ['ALL'], // This will hold the corresponding country codes
      companies: []
    };
  },
  computed: {
    ...mapState({
      token: state => state.auth.token
    }),
    countryOptions() {
      const countries = this.$t('countries'); // Fetches the countries translations based on the current locale
      return Object.keys(countries).map(code => {
        return `${countries[code]}`
        // The label that Vue Multiselect will display
      });
    },
    customLabel(option) {
      return option.code; // Assumes that each option is an object with a 'name' property
    },
  },
  watch: {
    selectedCountry() {
      this.updateCountryCodes();
    },
  },
  mounted() {

    getSectorCompanyList(this.token, this.sector.id, this.profile , this.countryCodes).then(list => {

      this.companies = list;

    });

  },
  methods: {
    getCountryCode(countryName) {
      const countries = this.$t('countries'); // Assuming this gives an object like { az: "Azerbaijan", ... }
      // Find the country code by searching through the countries object
      const countryCode = Object.keys(countries).find(key => countries[key] === countryName);
      return countryCode || null; // Return the country code if found, otherwise return null
    },
    updateCountryCodes() {
      this.countryCodes = this.selectedCountry.map(countryName => this.getCountryCode(countryName));
      getSectorCompanyList(this.token, this.sector.id, this.profile , this.countryCodes).then(list => {

        this.companies = list;

      });
    },
    getPhoto(path, size) {
      return getPhoto(path, size);
    },
    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },
  }


}
</script>
<style>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}
</style>